// Cobrar con el datáfono de recepción y el QR de pago.
export const datafono = {
  card: {
    name: "Card terminal",
    description: "Charge with the front-desk card terminal from the booking",
    count: "{count} terminal | {count} terminals",
  },
  settings: {
    title: "Front-desk card terminals",
    lead: "Charge with the card terminal from the booking: the amount shows on the device, the guest taps or inserts the card and the booking is marked as paid automatically.",
    listTitle: "Your terminals",
    add: "Add terminal",
    loading: "Loading…",
    empty: "You don't have any card terminal connected yet.",
    simulatorTag: "Simulator",
    online: "Online",
    offlineSince: "Offline · last seen {when}",
    neverConnected: "Not connected yet",
    bridgeVersion: "bridge {version}",
    token: "token",
    newToken: "New token",
    remove: "Remove",
    howTitle: "How to connect it",
    how1: "Add the terminal here and copy its token (it's only shown once).",
    how2: "On the front-desk computer the terminal is plugged into, start the WACheckin bridge with that token.",
    how3: "When it shows «Online» here, you can charge from any booking: Add payment → Card / terminal.",
    bankNote: "With Redsys you need to sign up with your bank for «TPV-PC» (Implantado mode) and a terminal certified for it. A standalone WiFi or 4G terminal can't be connected.",
    addTitle: "Add terminal",
    nameLabel: "Name",
    namePlaceholder: "For example: Front desk",
    typeLabel: "Type",
    typeReal: "Redsys terminal (TPV-PC)",
    typeRealHint: "Your bank's terminal, plugged into the front-desk computer.",
    typeSim: "Simulator",
    typeSimHint: "To test the flow without a device. Moves no money.",
    cancel: "Cancel",
    saving: "Saving…",
    create: "Add",
    saveError: "Couldn't save. Please try again.",
    loadError: "Couldn't load the terminals.",
    tokenTitle: "Terminal token",
    tokenLead: "Enter these two values in the bridge on the front-desk computer.",
    apiLabel: "Server",
    tokenLabel: "Token",
    copy: "Copy",
    copied: "Copied",
    tokenOnce: "Save it now: it won't be shown again. If it's lost, generate a new one and the old one stops working.",
    done: "Done",
    newTokenConfirm: "Generate a new token for «{name}»? The current one will stop working and must be entered again in the bridge.",
    removeConfirm: "Remove the terminal «{name}»? Charges can no longer be sent to it.",
    removed: "Terminal removed.",
  },
  add: {
    sendTitle: "Charge on the terminal",
    sendHint: "The amount shows on the device and the booking is marked as paid automatically when the card is used.",
    online: "online",
    offline: "offline",
    noneOnline: "No terminal is online right now. Check that the front-desk computer is on and the bridge is running.",
    manualTitle: "Already charged, just record it",
    manualHint: "It's recorded as paid without going through the terminal.",
    submit: "Charge on the terminal",
  },
  line: {
    pendiente: "Sending to terminal",
    enviado: "On the terminal",
    sin_respuesta: "No response · check",
  },
  cobro: {
    terminal: "Terminal",
    cancel: "Cancel charge",
    hide: "Keep it in the background",
    notCharged: "It wasn't charged",
    wasCharged: "Yes, it was charged",
    retry: "Try again",
    close: "Close",
    authCode: "Authorization {code}",
    genericError: "It couldn't be completed. Please try again.",
    title: {
      pendiente: "Sending to the terminal…",
      enviado: "Ask for the card",
      cobrado: "Charged",
      rechazado: "Card declined",
      cancelado: "Charge cancelled",
      error: "The terminal returned an error",
      caducado: "The terminal didn't respond",
      sin_respuesta: "Was it charged?",
    },
    text: {
      pendiente: "The amount will appear on the terminal in a few seconds.",
      enviado: "The amount is on the terminal. As soon as it's paid, the booking is marked automatically.",
      cobrado: "This payment is now recorded on the booking.",
      rechazado: "Nothing was charged.",
      cancelado: "Nothing was charged.",
      error: "Nothing was charged.",
      caducado: "Nothing was charged.",
      sin_respuesta: "The terminal didn't return the result. Check the device or its receipt before charging again.",
    },
  },
  qr: {
    button: "Show QR",
    title: "Scan to pay",
    text: "The guest scans it with their phone and pays on the gateway's secure page. The booking is marked as paid automatically.",
    copy: "Copy link",
    copied: "Link copied",
    close: "Close",
  },
};
